// client/src/api/fetch.ts
// Front robuste: ne plante pas si la réponse n'est pas du JSON (HTML, vide, etc.)
// Renvoie toujours un objet { ok, status, data?, message?, raw? }

const API_BASE = process.env.REACT_APP_API_URL || "";

enum Methods {
  POST = "POST",
  GET = "GET",
  UPDATE = "PUT",
  DELETE = "DELETE",
}

export type ApiResult<T = any> = {
  ok: boolean;
  status: number;
  data?: T;
  message?: string;
  raw?: string;
};

const fetchApi = async <T = any>(
  method: string,
  path: string,
  body?: object,
  contentType?: string
): Promise<ApiResult<T>> => {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || undefined;

  const headers: Record<string, string> = {
    "Content-Type": contentType || "application/json",
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const url = `${API_BASE}${path}`;

  const resp = await fetch(url, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
    credentials: "same-origin",
  });

  if (resp.status === 401 && typeof window !== "undefined") {
    localStorage.removeItem("token");
  }

  const raw = await resp.text();
  let parsed: any = undefined;
  try {
    parsed = raw ? JSON.parse(raw) : undefined;
  } catch {
    // pas du JSON -> parsed reste undefined
  }

  const message =
    (parsed && (parsed.message || parsed.error)) ||
    resp.statusText ||
    (raw && raw.slice(0, 200));

  return {
    ok: resp.ok,
    status: resp.status,
    data: parsed,
    message,
    raw,
  };
};

export const post = <T = any>(body: object, path: string, contentType?: string) =>
  fetchApi<T>(Methods.POST, path, body, contentType);

export const get = <T = any>(path: string) => fetchApi<T>(Methods.GET, path);

export const update = <T = any>(body: object, path: string) =>
  fetchApi<T>(Methods.UPDATE, path, body);

export const deleteItem = <T = any>(path: string) =>
  fetchApi<T>(Methods.DELETE, path);